import {Page} from '../lib/material-ui-components'
import {AuthSystem} from '../lib/auth-system'
import {getCurrentLoginUrl} from '../lib/login-url-generator'

declare let React: any
declare let ReactRouterDOM: any

const {withRouter} = ReactRouterDOM

const LoginDisplay = withRouter(({location, history}) => {
  const authSystem = AuthSystem.getInstance()
  const loginUrl = getCurrentLoginUrl()
  const authStatus = authSystem.getAuthStatus()

  const formatExpiryTime = (timestamp: number): string => {
    const date = new Date(timestamp)
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  // Genera QR code usando una libreria online (QR Server API)
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(loginUrl)}`

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(loginUrl)
      alert('✅ URL copiato negli appunti!')
    } catch (error) {
      // Fallback per browser che non supportano clipboard API
      const textArea = document.createElement('textarea')
      textArea.value = loginUrl
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      alert('✅ URL copiato negli appunti!')
    }
  }

  return (
    <Page title='Accesso Museo Genio - QR Code' top={true}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        textAlign: 'center',
        padding: '20px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '20px',
        margin: '20px',
        color: 'white'
      }}>
        <h1 style={{
          fontSize: '2.5em',
          marginBottom: '10px',
          fontWeight: 'bold'
        }}>
          🏛️ Museo Genio
        </h1>
        
        <h2 style={{
          fontSize: '1.5em',
          marginBottom: '30px',
          opacity: '0.9'
        }}>
          Accesso alle Esperienze Immersive
        </h2>

        {/* QR Code */}
        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '15px',
          marginBottom: '30px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
        }}>
          <img 
            src={qrCodeUrl} 
            alt="QR Code per accesso"
            style={{
              maxWidth: '300px',
              width: '100%',
              height: 'auto'
            }}
          />
        </div>

        {/* URL Testuale */}
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '30px',
          maxWidth: '600px',
          width: '100%',
          wordBreak: 'break-all'
        }}>
         
          <div style={{
            background: 'rgba(0,0,0,0.2)',
            padding: '15px',
            borderRadius: '8px',
            fontFamily: 'monospace',
            fontSize: '0.9em',
            marginBottom: '15px',
            border: '1px solid rgba(255,255,255,0.2)'
          }}>
             <p style={{ marginBottom: '15px', fontSize: '1.2em' }}>
            🔗 URL di Accesso
          </p>
            {loginUrl}
          </div>
          <button
            onClick={copyToClipboard}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '25px',
              padding: '10px 25px',
              cursor: 'pointer',
              fontSize: '1em',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.3)'
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.2)'
            }}
          >
            📋 Copia URL
          </button>
        </div>

        {/* Informazioni di Validità */}
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '20px',
          maxWidth: '500px',
          width: '100%'
        }}>
       
          <div style={{ textAlign: 'left', lineHeight: '1.6' }}>
          <p style={{ marginBottom: '15px', fontSize: '1.2em' }}>
            ⏰ Informazioni di Validità
          </p>
            <p><strong>🔗 URL di Login:</strong> Valido fino a {authStatus.urlExpiresAt ? formatExpiryTime(authStatus.urlExpiresAt) : 'Non disponibile'}</p>
            <p><strong>🔑 Token di Accesso:</strong> Valido per 2 ore dopo l'accesso</p>
            <p><strong>📱 Compatibilità:</strong> Funziona su tutti i dispositivi</p>
          </div>
        </div>

        {/* Istruzioni */}
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '20px',
          borderRadius: '10px',
          maxWidth: '500px',
          width: '100%'
        }}>
        
          <div style={{ textAlign: 'left', lineHeight: '1.6' }}>
          <p style={{ marginBottom: '15px', fontSize: '1.2em' }}>
            📋 Come Accedere
          </p>
            <p><strong>1.</strong> Scansiona il QR code con il tuo smartphone</p>
            <p><strong>2.</strong> Oppure copia l'URL e aprilo nel browser</p>
            <p><strong>3.</strong> Clicca su "Entrare" nella pagina di login</p>
            <p><strong>4.</strong> Goditi le esperienze immersive per 2 ore</p>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '30px',
          padding: '15px',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          fontSize: '0.9em',
          opacity: '0.8'
        }}>
          <p>🎨 Esperienze 3D Immersive • 🏛️ Museo Genio • 🔐 Accesso Sicuro</p>
        </div>
      </div>
    </Page>
  )
})

export {LoginDisplay} 